// src/components/About.jsx
import { motion } from 'framer-motion';
import ResponsiveImage from './ResponsiveImage';
import { useSiteData } from '../context/SiteDataContext';
import { getImageUrl } from '../lib/supabase';

function About() {
  const { about, loading } = useSiteData();

  return (
    <motion.section
      id="about"
      className="page-section position-relative overflow-hidden"
      style={{ color: '#495057' }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.01 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background: 'radial-gradient(circle at 20% 80%, rgba(66, 89, 168, 0.08) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(66, 89, 168, 0.08) 0%, transparent 50%)',
          pointerEvents: 'none',
        }}
      />

      <div className="container position-relative py-5">
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h2
            className="section-heading text-uppercase responsive-heading fw-bold mb-4"
            style={{ color: '#4259A8', fontSize: '2.5rem', letterSpacing: '2px' }}
          >
            O nama
          </h2>
          <div
            className="mx-auto mb-4"
            style={{ width: '80px', height: '4px', background: 'linear-gradient(90deg, #4259A8, #2E8DD7)', borderRadius: '2px' }}
          />
        </motion.div>

        {/* Block 1 — image left, text right */}
        <div className="row align-items-center mb-5">
          <motion.div
            className="col-lg-6 mb-4 mb-lg-0"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.01 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <div className="rounded-4 overflow-hidden shadow-lg">
              <ResponsiveImage
                className="img-fluid w-100"
                src={getImageUrl(about?.[1]?.image_url ?? 'poliklinika-8.webp')}
                sizes="(max-width: 768px) 100vw, 50vw"
                alt="Vanjska slika"
                objectFit="cover"
                style={{ height: '350px' }}
              />
            </div>
          </motion.div>

          <motion.div
            className="col-lg-6"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.01 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            <p className="text-muted mb-0 lh-lg f-p1">
              {loading ? '…' : about?.[1]?.body}
            </p>
          </motion.div>
        </div>

        {/* Block 2 — image right, text left */}
        <div className="row align-items-center">
          <motion.div
            className="col-lg-6 order-lg-2 mb-4 mb-lg-0"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.01 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="rounded-4 overflow-hidden shadow-lg">
              <ResponsiveImage
                className="img-fluid w-100"
                src={getImageUrl(about?.[2]?.image_url ?? 'poliklinika-5.webp')}
                sizes="(max-width: 768px) 100vw, 50vw"
                alt="Unutarnja slika"
                objectFit="cover"
                style={{ height: '350px' }}
              />
            </div>
          </motion.div>

          <motion.div
            className="col-lg-6 order-lg-1"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.01 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <p className="text-muted mb-0 lh-lg f-p1">
              {loading ? '…' : about?.[2]?.body}
            </p>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
}

export default About;